export const createChatSlice = (set, get) => ({
  // Chat state
  chatHistory: [],

  // Chat actions
  addChatMessage: (message) =>
    set((state) => ({
      chatHistory: [...state.chatHistory, message]
    })),

})